import { bffRetailMedia } from '~/middlewares/axios'

const baseURL = `/campaign`

/**
 * LIST
 * Retorna o status de aprovação de cada sub-publisher para uma campanha de
 * rede, incluindo os destination_urls definidos por cada um.
 */
export const listSubpublisherApprovalStatusKey =
  'listSubpublisherApprovalStatus'

export const listSubpublisherApprovalStatusService = ({
  id
}: ListSubpublisherApprovalStatusResquest) =>
  bffRetailMedia.get<ListSubpublisherApprovalStatusResponse>(
    `${baseURL}/${id}/network/approval-status`
  )
